module.exports = __webpack_public_path__ + "static/media/Tombeau-picture-2.e49239b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Tombeau/Tombeau-picture-2.jpg
// module id = 604
// module chunks = 0